/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import {
  Briefcase,
  Crown,
  Gem,
  Rocket,
  Shield,
  Sparkles,
  Star,
  Zap,
} from "lucide-react";

const ICON_MAP = {
  crown: Crown,
  shield: Shield,
  star: Star,
  sparkles: Sparkles,
  rocket: Rocket,
  gem: Gem,
  zap: Zap,
  briefcase: Briefcase,
};

export const getTierIconComponent = (iconKey) => {
  const normalizedKey = String(iconKey ?? "").trim().toLowerCase();
  return ICON_MAP[normalizedKey] ?? Crown;
};
